<form (ngSubmit)="submitSms(formGroup.value)" autocomplete="off" novalidate>
  <div class="sms" [formGroup]="formGroup">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <mat-form-field appearance="outline" class="ut-sms-chips-list">
            <mat-chip-grid #chipList>
              <mat-chip-row
                *ngFor="let phone of phoneList"
                [removable]="removable"
                (removed)="removePhoneNumber(phone)"
                class="ut-sms-chip">
                {{phone.phoneNumber}} - {{phone.recipientName}}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
              </mat-chip-row>
              <input placeholder="Mobile number"
                     formControlName="mobile"
                     [matChipInputFor]="chipList"
                     [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                     [matChipInputAddOnBlur]="addOnBlur"
                     (matChipInputTokenEnd)="addPhoneNumber($event)" />
            </mat-chip-grid>
          </mat-form-field>
          <mat-error *ngIf="sms.recipient.length === 0">
            Please close this modal and reopen if you have removed all applicants from this list
          </mat-error>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <mat-form-field appearance="outline">
            <mat-label>Tag</mat-label>
            <mat-select placeholder="Tag" formControlName="tag" (selectionChange)="selectSmsTag($event.value)">
              <ng-container *ngIf="activeLook === 'crumbs'">
                <mat-option [value]="'freehand'">Freehand</mat-option>
                <mat-option *ngFor="let tag of smsTags" [value]="tag">
                  {{ tag }}
                </mat-option>
              </ng-container>

              <ng-container *ngIf="activeLook !== 'crumbs'">
                <mat-option *ngFor="let tag of smsTags" [value]="tag">
                  {{tag}}
                </mat-option>
              </ng-container>
            </mat-select>
            <mat-error *ngIf="formGroup.get('tag').hasError('required')">
              Please select a tag
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <mat-form-field appearance="outline" *ngIf="activeLook === 'crumbs'">
            <mat-label>Template</mat-label>
            <mat-select placeholder="Template" formControlName="template" (selectionChange)="selectSmsTemplate($event.value)">
              <mat-optgroup [label]="'Your templates'" *ngIf="filteredMyTemplates.length > 0">
                <mat-option *ngFor="let template of filteredMyTemplates" [value]="template">
                  {{ template.name }}
                </mat-option>
              </mat-optgroup>
              <mat-optgroup [label]="'Global templates'" *ngIf="filteredGlobalTemplates.length > 0">
                <mat-option *ngFor="let template of filteredGlobalTemplates" [value]="template">
                  {{ template.name }}
                </mat-option>
              </mat-optgroup>
            </mat-select>

            <mat-error *ngIf="formGroup.get('template').hasError('required')">
              Please select a template
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" *ngIf="activeLook !== 'crumbs'">
            <mat-label>Template</mat-label>
            <mat-select placeholder="Template" formControlName="template" (selectionChange)="selectSmsTemplate($event.value)">
              <mat-option *ngFor="let template of filteredGlobalTemplates" [value]="template">
                {{ template.name }}
              </mat-option>
            </mat-select>

            <mat-error *ngIf="formGroup.get('template').hasError('required')">
              Please provide a message
            </mat-error>
          </mat-form-field>

          <ng-container *ngIf="filteredGlobalTemplates.length === 0 && formGroup.value.tag && !templateLoading">
            <mat-error><small>No templates tagged under "{{formGroup.value.tag}}"</small></mat-error>
          </ng-container>

        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <mat-form-field appearance="outline">
            <mat-label>Message</mat-label>
            <textarea matInput placeholder="Message" rows="5" formControlName="message"></textarea>
            <mat-error *ngIf="formGroup.get('message').hasError('required')">
              Please provide a message
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row pt-2 pb-2">
        <div class="col-sm-6">
        </div>
        <div class="col-sm-6 text-end">
          <button mat-raised-button type="submit" color="primary">Submit</button>
        </div>
      </div>
    </div>
  </div>
</form>
